module.exports = __webpack_public_path__ + "static/media/ProximaNovaA-Regular.6e8adc60.woff";